import { db } from "@/fstore";
import sortBy from "lodash/sortBy";
//import values from "lodash/values";
import reverse from "lodash/reverse";

export default {
  namespaced: true,
  state: {
    binders: [],
    shows: {},
    orderedShows: [],
    oldestDocSnapshot: null,
    oldestDocSnapshotShow: null,
    limitNumberFirstHit: 5,
    queryInProgress: false,
    reachedLastSnapshot: false
  },
  getters: {},
  mutations: {
    setOrderedShows(state) {
      console.log("setOrderedShows");
      state.orderedShows = reverse(sortBy(state.shows, "updated_at"));
      state.queryInProgress = false;
    }
  },
  actions: {
    loadShowNext({ rootState, state, commit, dispatch }, limit) {
      console.log("loading shows");

      if (!limit) {
        limit = state.limitNumberFirstHit;
      }

      state.queryInProgress = true;

      var query = db
        .collection("editor_shows")
        .where("user", "==", rootState.user.uid)
        .where("deleted", "==", false)
        .orderBy("updated_at", "desc");

      if (state.orderedShows.length == 0) {
        // First load.
        query = query.limit(limit);
      } else {
        // Subsequent loads.
        query = query.startAfter(state.oldestDocSnapshot);
        query = query.limit(limit);
      }

      query.onSnapshot(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          var doc_data = doc.data();
          console.log(doc.id);
          console.log(doc_data.updated_at);
          state.shows[doc.id] = doc_data;
          if (!state.oldestDocSnapshotShow) {
            state.oldestDocSnapshot = doc;
            state.oldestDocSnapshotShow = doc_data;
          } else if (
            doc_data.updated_at < state.oldestDocSnapshotShow.updated_at
          ) {
            console.log("New oldest");
            state.oldestDocSnapshot = doc;
            state.oldestDocSnapshotShow = doc_data;
          }
        });
        commit("setOrderedShows");
        dispatch("queryForNextShow");
      });
    },
    queryForNextShow({ rootState, state }) {
      /*
      Simple query to see if there is a next item.
      This could be done by querying limit=n+1 in loadShowNext,
      but that would mess up the snapshot listener when items are deleted.
      */
      var query = db
        .collection("editor_shows")
        .where("user", "==", rootState.user.uid)
        .where("deleted", "==", false)
        .orderBy("updated_at", "desc");

      query = query.startAfter(state.oldestDocSnapshot);
      query = query.limit(1);
      // Do not listen, just get.
      query
        .get()
        .then(function(querySnapshot) {
          console.log("querySnapshot", querySnapshot);
          if (querySnapshot.empty) {
            state.reachedLastSnapshot = true;
          } else {
            state.reachedLastSnapshot = false;
          }
          querySnapshot.forEach(function(doc) {
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    removeShowFromList({ state, commit }, show_key) {
      // Immediately remove the show from the active show list.
      delete state.shows[show_key];
      commit("setOrderedShows");
    }
  }
};
